//src/Components/Buttons/DualButton/index.tsx
import { ReactNode } from 'react';
import Button, { ButtonTheme } from '../Button';

export default function DualButton({
  buttonOne,
  buttonTwo,
  onChange,
  activeTheme = 'green-fill',
  inactiveTheme = 'gray-outline',
  value,
}: {
  value?: boolean;
  onChange: (b?: boolean) => void;
  buttonOne: ReactNode;
  buttonTwo: ReactNode;
  activeTheme?: ButtonTheme;
  inactiveTheme?: ButtonTheme;
}) {
  return (
    <div className="flex w-full justify-between flex-wrap gap-2 text-sm  py-2 rounded-md">
      <Button
        theme={value === true ? activeTheme : inactiveTheme}
        onClick={() => onChange(value === true ? undefined : true)}
      >
        {buttonOne}
      </Button>
      <Button
        theme={value === false ? activeTheme : inactiveTheme}
        onClick={() => onChange(value === false ? undefined : false)}
      >
        {buttonTwo}
      </Button>
    </div>
  );
}
